if (!customElements.get('wd-recently-viewed-products')) {
  customElements.define(
    'wd-recently-viewed-products',
    class WdRecentlyViewedProducts extends HTMLElement {
      constructor() {
        super();

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '0px 0px 400px 0px' });
        }
      }

      init() {
        const queryUrl = this.getQueryUrl();
        if (!queryUrl) {
          this.removeSection();
          return;
        }

        fetch(queryUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) return;

            const recommendations = sectionInnerHTML.querySelector('wd-recently-viewed-products');
            if (recommendations && recommendations.innerHTML.trim().length) {
              const section = recommendations.querySelector('.section');
              section.classList.remove('hidden');

              this.innerHTML = recommendations.innerHTML;
              requestAnimationFrame(() => {
                window.productRowScheduleEqualize && window.productRowScheduleEqualize()
              })
            }

            if (recommendations && recommendations.querySelector('.product-card')) {
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
            } else {
              this.removeSection();
              this.dispatchEvent(new CustomEvent('recommendations:empty'));
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }

      getQueryUrl() {
        let rawItems = [];
        try {
          rawItems = JSON.parse(window.localStorage.getItem('hypertheme:recently-viewed') || '[]');
        } catch (_) {
          rawItems = [];
        }

        const items = Array.isArray(rawItems)
          ? rawItems
              .map((item) => Number.parseInt(item, 10))
              .filter((item) => Number.isInteger(item) && item > 0)
          : [];

        const productId = Number.parseInt(this.dataset.productId, 10);
        const productsToShow = Number.parseInt(this.dataset.productsToShow, 10) || 0;

        if (!Number.isNaN(productId) && items.includes(productId)) {
          items.splice(items.indexOf(productId), 1);
        }

        if (items.length > 0 && productsToShow > 0) {
          const queryParams = items
            .map((item) => 'id:' + item)
            .slice(0, productsToShow)
            .join(' OR ');

          return this.dataset.url + queryParams;
        }

        return false;
      }

      removeSection() {
        this.remove();
      }

      sendTrekkieEvent(numberProducts) {
        if (!window.ShopifyAnalytics || !window.ShopifyAnalytics.lib || !window.ShopifyAnalytics.lib.track) {
          return;
        }
        let didPageJumpOccur = this.getBoundingClientRect().top <= window.innerHeight;

        window.ShopifyAnalytics.lib.track('Recently Viewed Products Displayed', {
          theme: Shopify.theme.name,
          didPageJumpOccur: didPageJumpOccur,
          numberOfRecommendationsDisplayed: numberProducts,
        });
      }
    }
  );
}
